// extracted by mini-css-extract-plugin
module.exports = {"side_menu_container":"SideMenu_side_menu_container__2voNN","content_wrapper":"SideMenu_content_wrapper__9rRgG","toggled":"SideMenu_toggled__15TAm"};